export default "__VITE_ASSET__D9LcVuX2__"